import { Button, Carousel, Container, Image, Modal } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../auth-config";
import { authenticate } from "../../services/user-service";
import { useState } from "react";
import logo from "../../assets/godrej.svg"
import loginImg from "../../assets/logo/loginImg.jpeg";

export default function Login(props) {
  const { instance } = useMsal();
  const [showSessionModal, setShowSessionModal] = useState(false);

  async function handleLogin(instance) {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (e) {
      console.error(e);
    }
  }

  const handleContinueSession = () => {
    setShowSessionModal(false);
  };

  const handleCloseExistingSessions = async () => {
    try {
      const authResponse = await authenticate(true);
      if (authResponse.success) {
        setShowSessionModal(false);
      } else {
        alert('Failed to terminate existing sessions');
      }
    } catch (error) {
      alert('Failed to terminate existing sessions');
    }
  };

  return (
     <><div className="loginLeftImageGodrej ">
      <img className="logo"
        src={logo}
        alt="logo" />
      <span class="headerLink">Godrej Enterprises Group</span>
    </div><Container bsPrefix="login-container">
        <div className="login-page">
          <div className="login-image-container align-items-center">
          <Image className="login-image" src={loginImg} alt="First slide" />
          </div>

          <div className="login-box text-center">

            {/* <Image className="logo" src={logo} alt="logo" /> */}
           <div className="login-user">
            {props.errorMessage && <div className="text-label-with-error">{props.errorMessage}</div>}
            <h1 className="login-heading">Godrej Consumer Finance Portal</h1>
          </div>
            <div className="Login-btn-container text-center">
              <Button onClick={() => handleLogin(instance)}
                className="login-btn">
                LOGIN
              </Button>
            </div>
          </div>

        </div>
      </Container>
      
      <Modal show={showSessionModal} onHide={() => setShowSessionModal(false)} centered>
        <Modal.Header>
          <Modal.Title>Active Session Detected</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          User already has an active session. Please choose an option:
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleContinueSession}>
            Continue Current Session
          </Button>
          <Button variant="primary" onClick={handleCloseExistingSessions}>
            Close Existing Sessions
          </Button>
        </Modal.Footer>
      </Modal>
      </>
  );
}
